<div class="flex flex-col items-center gap-3" *transloco="let t">
  <div class="w-3/4">
    <span class="text-xs text-gray-400">3/3</span>
    <div class="mb-8 text-xl font-semibold text-gray-700">
      {{ t("free-test-subscription-page.start_my_free_test_heading") }}
    </div>
    <p>{{ t("free-test-subscription-page.start_my_free_test_subheading") }}</p>
    @if (belowFreeTestAdSpendThreshold()) {
      <div class="mb-4 flex items-center font-semibold">
        <span [className]="ICON_WARNING_TRIANGLE + ' text-orange-500 mr-2 text-lg'"></span
        ><span>{{ t("free-test-subscription-page.start_my_free_test_warning") }}</span>
      </div>
      <p>
        {{ t("free-test-subscription-page.billing_settings_info_message") }}
      </p>
      <div class="mt-4 flex flex-col items-center gap-3">
        <IButton [label]="t('common.start_free_test_cta')" (onClick)="openFreeTestModal()"></IButton>
        <a class="cursor-pointer text-gray-400 hover:text-gray-500" (click)="skipOnboarding()">{{
          t("common.i_will_do_it_later")
        }}</a>
      </div>
    } @else {
      <div class="my-8 flex flex-col items-center gap-3">
        <IButton [label]="t('common.start_free_test_cta')" (onClick)="openFreeTestModal()"></IButton>
        <a class="cursor-pointer text-gray-400 hover:text-gray-500" (click)="skipOnboarding()">{{
          t("common.i_will_do_it_later")
        }}</a>
      </div>
      <div class="mb-4 flex items-center font-semibold">
        <span [className]="ICON_WARNING_TRIANGLE + ' text-orange-500 mr-2 text-lg'"></span
        ><span>{{ t("free-test-subscription-page.start_my_free_test_warning") }}</span>
      </div>
      <p>
        {{ t("free-test-subscription-page.billing_settings_info_message") }}
      </p>
    }
  </div>

  @if (belowFreeTestAdSpendThreshold()) {
    <div class="mt-24 w-3/4 rounded-lg border border-slate-300 bg-slate-50 p-4 text-slate-800" role="alert">
      <div class="flex items-center">
        <h2 class="text-lg font-medium">
          <span class="icon-[lucide--lightbulb] mr-2"></span>{{ t("free-test-subscription-page.good_to_know") }}
        </h2>
      </div>
      <p [innerHTML]="autopilotSuggestionMessage"></p>
      <p>
        {{ t("free-test-subscription-page.autopilot_ad_2") }}
      </p>
      <div class="flex items-center justify-between">
        <div class="text-sm text-gray-500">{{ t("free-test-subscription-page.pricing_autopilot") }}</div>
        <a
          class="text-main-600 hover:text-main-800"
          href="https://www.m19.com/products/product-autopilot"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ t("free-test-subscription-page.learn_more") }}
        </a>
      </div>
      <div class="mt-4 flex items-center justify-center">
        <IButton
          [label]="t('free-test-subscription-page.try_autopilot_instead')"
          href="https://autopilot.m19.com"
        ></IButton>
      </div>
    </div>
  }
</div>
<ng-template #accountSelection *transloco="let t">
  <div class="flex max-h-full flex-col gap-4 overflow-hidden">
    <div class="space-y-2 text-sm text-gray-500">
      <div>{{ t("onboarding.start_ads_auto_info") }}</div>
      <div>{{ t("onboarding.start_ads_auto_info_2") }}</div>
      <div class="mt-2">{{ t("onboarding.start_free_test_disclaimer") }}</div>
    </div>
    <hr class="my-4 border-gray-200" />
    <div class="min-h-0 flex-1 shrink-0 p-1">
      <select-accounts-page
        [accountMarketplaces]="accountMarketplaces()!"
        [disabledAccountsMarketplaces]="disabledAccountsMarketplaces()"
        [orgId]="organization?.organizationId"
        (selectionChange)="selectedAccountMarketplaces.set($event)"
      />
    </div>
    <div class="mt-2 flex justify-end gap-4">
      <IButton [label]="t('common.cancel')" color="white" (onClick)="accountSelectionModalRef()?.close()" />
      <IButton
        [label]="t('common.start_free_test_cta')"
        (onClick)="activateFreeTest()"
        [loading]="activatingFreeTest()"
        [disabled]="selectedAccountMarketplaces().length === 0"
      />
    </div>
  </div>
</ng-template>
